import React from 'react'
import { localize } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'

const ClaimLinePractitioner = (props) => {
  return (
    <Row className='claimLineRow' between='xs'>
      <Col xs={12} lg={3}>
        <p><span className='bold'>{localize('pages.claims.claimLineDetails.claimPayment')}</span></p>
      </Col>
      <Col xs={12} lg={9}>
        {(props.type === 'Claim' || props.type === 'Réclamer') ? (
          <p>{localize('pages.claims.claimLineDetails.practionerClaim')}</p>
        ) : (
          <p>{localize('pages.claims.claimLineDetails.practionerEstimate')}</p>
        )
        }
      </Col>
    </Row>
  )
}

export default ClaimLinePractitioner



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimLinePractitioner.js